import { Grid } from "@mui/system";

import VerticalLinearStepper from "../VerticalLinearStepper";

import { RecapCard } from "../../RecapCard";
import { Alert, Button, Typography } from "@mui/material";
import { LiveCodeBlock } from "../../LiveCodeBlock";

export const KdappontLesson5 = () => {
  const subjectBlocks = [
    {
      label: "Block level element VS Inline level element",
      main: (
        <>
          <LiveCodeBlock
            code={`<header>Ik ben block-level header</header>
<p>Ik ben een block-level p</p>
<a href="glr.nl">Ik ben een inline a</a>
<img src="/presentation-data/KDAPPONT2/intro/ai.jpeg"  />
<span>Ik ben een inline span</span>`}
          />
          <br />
          Bepaalt of elementen horizontaal of verticaal stapelen
        </>
      ),
    },
    {
      label: "<div> tag",
      main: (
        <>
          <LiveCodeBlock code={`<div>Een block-level divider</div>`} />
          <br />
          Niet semantisch. Indien mogelijk voorkomen.
        </>
      ),
    },
    {
      label: "File paths",
      main: (
        <>
          <LiveCodeBlock
            live={false}
            code={`<img src="picture.jpg">
<img src="subfolder/picture.jpg">
<img src="/picture.jpg">
<img src="../picture.jpg">`}
          />
          <br />
          <img src="/presentation-data/KDAPPONT2/lesson5/folders.png" alt="" />
        </>
      ),
    },
    {
      label: "HTML Characters, Symbols en Emoji's",
      main: (
        <>
          Karakters zoals &lt; en &gt; zijn gereserveerd in HTML. <br />
          <LiveCodeBlock code={`<main>&lt; &gt; &trade;</main>`} />
          <br />
          <LiveCodeBlock code={`<main> <> </main>`} live={false} />
          <br />
          <LiveCodeBlock code={`<main> 😍 🏆 🤖 </main>`} live={false} />
          <br />
          <img
            style={{ maxWidth: "100%" }}
            src="/presentation-data/KDAPPONT2/lesson5/characters.png"
            alt=""
          />
        </>
      ),
    },
    {
      label: "Layout & Semantics",
      main: (
        <>
          <img src="/presentation-data/KDAPPONT2/lesson5/layout.jpeg" alt="" />
        </>
      ),
    },
    {
      label: "HTML Style Guide",
      main: (
        <>
          Dingen die je vooral niet moet doen. <br />
          <br />
          <Button
            target="_blank"
            variant="contained"
            href="https://www.w3schools.com/html/html5_syntax.asp"
          >
            Style Guide
          </Button>
        </>
      ),
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "Planning",
          description: "",
          content: (
            <>
              <img
                src="/presentation-data/KDAPPONT2/lesson5/planning-l5.png"
                width="100%"
                alt=""
              />
            </>
          ),
        },
        {
          label: "👨🏼‍🏫 Voor vandaag - Les #5",
          description: ``,
          content: (
            <Grid container columns={4} spacing={2}>
              {subjectBlocks.map((subject) => (
                <Grid size={2} sx={{ "& > *": { height: "100%" } }}>
                  <RecapCard subject={subject} />
                </Grid>
              ))}
            </Grid>
          ),
        },
        {
          label: "🚀 Digitaal Lesmateriaal - W3Schools - Aan de slag!",
          description: `Digitaal lesmateriaal ➡️ KD Appont ➡️ Module 1 :: HTML ➡️ LES 5`,
          content: (
            <Alert severity="error" sx={{ alignItems: "center" }}>
              <Typography variant="h5">
                Maak uiteraard eerst je oefeningen en opdrachten van Les 3 & 4
                af
              </Typography>
            </Alert>
          ),
        },
      ]}
    />
  );
};
